import { render, staticRenderFns } from "./StepRata.vue?vue&type=template&id=316b2e21&scoped=true"
import script from "./StepRata.vue?vue&type=script&lang=js"
export * from "./StepRata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316b2e21",
  null
  
)

export default component.exports